import {
  FAQ_GET_LIST,
  FAQ_REQUEST,
  FAQ_SUCCESS,
  FAQ_FAILURE
} from '@/store/types'

import axios from '@/store/axios'

const state = {
  faq: null,
  isLoading: false,
  error: null,
  meta: {}
}

const getters = {
  getFaq: (state) => state.faq,
  isFaqLoading: (state) => state.isLoading,
  getFaqTotalCount: (state) =>
    state.meta.totalCount || (state.faq ? state.faq.length : 0)
}

const actions = {
  [FAQ_GET_LIST]: (
    { commit },
    { searchTerm, category, page, perPageCount }
  ) => {
    return new Promise((resolve, reject) => {
      commit(FAQ_REQUEST)

      const params = {}
      if (searchTerm) params.searchTxt = searchTerm
      if (category) params.catgryCd = category === '0' ? null : category
      if (page) params.pageNo = page
      if (perPageCount) params.pageRow = perPageCount

      axios
        .get('customer/faq/list', { params })
        .then((resp) => {
          commit(FAQ_SUCCESS, {
            faq: resp.data.result.faqList,
            meta: resp.data.page
          })
          resolve(resp)
        })
        .catch((err) => {
          commit(FAQ_FAILURE, err)
          reject(err)
        })
    })
  }
}

const mutations = {
  [FAQ_REQUEST]: (state) => {
    state.isLoading = true
  },
  [FAQ_SUCCESS]: (state, { faq, meta }) => {
    state.isLoading = false

    if (faq) state.faq = faq
    if (meta) state.meta = meta
  },
  [FAQ_FAILURE]: (state, err) => {
    state.isLoading = false
    state.error = err
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
